module.exports = __webpack_public_path__ + "img/alt-loc.922c0c1d.svg";